import React, { Component } from 'react';
import { submitCollaboration } from 'services/collabService'
import { ButtonReg } from 'atoms/Buttons';
import { Label } from 'atoms/Texts';
import { FormTxt, FormChips, FormChipsSearch } from 'atoms/Inputs';
import { InputWrapper, FilenameWrapper } from './styles';
import {
  COLLABORATION_REMARK,
  COLLABORATION_IMAGE,
  COLLABORATION_DOCUMENT,
  COLLABORATION_DEPARTMENT,
  COLLABORATION_ADD_CC
} from 'fixtures/collabTypes';
import { getUniqueDepts } from 'helpers/deptListHelper'
import { withTheme } from 'styled-components';

import Btn from './btn'
import Menu from './menu'

const icons = {
  [COLLABORATION_REMARK]: require('App/assets/images/ic_plus.png'),
  [COLLABORATION_DEPARTMENT]: require('App/assets/images/ic_share_green.png'),
  [COLLABORATION_IMAGE]: require('App/assets/images/ic_pic_orange.png'),
  [COLLABORATION_DOCUMENT]: require('App/assets/images/ic_doc_orange.png'),
  [COLLABORATION_ADD_CC]: require('App/assets/images/ic_user_bk.png'),
  SUBMITTING: require('App/assets/images/ic_plus.png'),
}

class CollaborationInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isShowMenu: false,
      isSubmitting: false,
      inputMode: COLLABORATION_REMARK,
      renderer: this.rendererRemark,
      content: {
        [COLLABORATION_REMARK]: '',
        [COLLABORATION_IMAGE]: [],
        [`name${COLLABORATION_IMAGE}`]: [],
        [COLLABORATION_DEPARTMENT]: [],
        [COLLABORATION_DOCUMENT]: [],
        [`name${COLLABORATION_DOCUMENT}`]: [],
        [COLLABORATION_ADD_CC]: [],
      }
    }
  }

  inputConfig = {
    border: this.props.theme.mocaGrey,
    rad: '6px',
    width: '100%',
    yxPadding: '9px 12px',
    mb: '0',
    mx: '16px'
  }

  // FUNCTION & HANDLERS ---------------------------------- //
  toggleMode() {
    const { isShowMenu } = this.state
    this.setState({ isShowMenu: !isShowMenu })
  }

  changeMode(val) {
    this.setState({ inputMode: val })
    this.toggleMode()
  }

  onChangeContent(val, field) {
    const mock = Object.assign(this.state.content)

    if (field === (COLLABORATION_IMAGE) || field === (COLLABORATION_DOCUMENT)) {
      const files = []
      const names = []
      for (var i = 0; i < val.length; i++) {
        const file = val[i]
        let reader = new FileReader()
        reader.addEventListener("load", (event) => {
          const fileObj = {
            ...field === (COLLABORATION_DOCUMENT) && { nameDisplay: file.name },
            fileBase64: event.target.result.split(',')[1]
          }
          files.push(fileObj)
          mock[field] = files
          this.setState({ content: mock })
        })
        reader.readAsDataURL(file)
        names.push(file.name)
      }

      mock[`name${field}`] = names
    } else {
      mock[field] = val
    }

    this.setState({ content: mock })
  }

  onSubmitCollab() {
    const { inputMode, content } = this.state
    const {
      userLogin: { userDetail },
      match: { params: { taskId } },
      taskType,
    } = this.props
    let data = content[inputMode]

    if (inputMode === COLLABORATION_ADD_CC) {
      data = content[inputMode].map(c => c.id)
    }

    this.setState({ inputMode: 'SUBMITTING' }, async () => {
      await submitCollaboration(inputMode, data, userDetail, taskId, taskType)
      this.onChangeContent((inputMode === COLLABORATION_REMARK ? '' : []), inputMode)
      this.onChangeContent([], COLLABORATION_ADD_CC)
      this.setState({ inputMode: COLLABORATION_REMARK })
    })
  }

  // RENDER SUBCOMPONENTS --------------------------------------- //
  rendererSUBMITTING() {
    return (
      <FilenameWrapper>
        <Label mb={'0'} size={'12px'}>Submitting...</Label>
      </FilenameWrapper>
    )
  }

  rendererREMARK() {
    return (
      <FormTxt
        placeholder={'Enter your remark'}
        mb={'16px'}
        value={this.state.content[COLLABORATION_REMARK]}
        onChangeVal={e => this.onChangeContent(e.target.value, COLLABORATION_REMARK)}
        {...this.inputConfig}
      />
    )
  }

  rendererIMAGE() {
    const { content: { nameIMAGE } } = this.state
    return (
      <FilenameWrapper>
        <Label mb={'0'} size={'12px'}>
          {nameIMAGE.length ? nameIMAGE.join(', ') : 'No file selected.'}
        </Label>
      </FilenameWrapper>
    )
  }

  rendererDOCUMENT() {
    const { content: { nameDOCUMENT } } = this.state
    return (
      <FilenameWrapper>
        <Label mb={'0'} size={'12px'}>
          {nameDOCUMENT.length ? nameDOCUMENT.join(', ') : 'No file selected.'}
        </Label>
      </FilenameWrapper>
    )
  }

  rendererDEPARTMENT() {
    const {
      isLoadingInput,
      depts,
      taskData: { concernedDepartment, sharedDepartment }
    } = this.props

    const deptList = getUniqueDepts(depts, concernedDepartment, sharedDepartment)

    return (
      <div className={'col-10 px-0'}>
        {isLoadingInput ?
          <Label mb={'0'} size={'12px'}>
            Loading department list...
          </Label> :
          <FormChips
            placeholder={'Select department'}
            options={deptList}
            dispField={'nameDisplay'}
            control={this.state.content.selections}
            onChangeVal={e => this.onChangeContent(e, COLLABORATION_DEPARTMENT)}
            {...this.inputConfig}
          />
        }
      </div>
    )
  }

  rendererADD_CC() {
    const { ccsList, getCCsData, taskData } = this.props
    const { content } = this.state
    return (
      <div className="col-10 px-0">
        <FormChipsSearch
          control={content[COLLABORATION_ADD_CC]}
          placeholder="Search Username"
          dispField="displayName"
          minLength={0}
          onSearch={e => getCCsData(e, taskData.pitId)}
          options={ccsList.data || []}
          isLoading={ccsList.isLoading}
          onChangeVal={e => this.onChangeContent(e, COLLABORATION_ADD_CC)}
          dropup
        />
      </div>
    )
  }

  // RENDER ---------------------------------------------------- //
  render() {
    const { isShowMenu, inputMode } = this.state
    return (
      <InputWrapper>
        <Btn icon={icons[inputMode]} fn={this.toggleMode.bind(this)} />
        <Menu isShow={isShowMenu ? 'block' : 'none'} fn={this.changeMode.bind(this)} />
        {this[`renderer${inputMode}`]()}
        <ButtonReg
          btnTxt={'Send'}
          width={'70px'}
          disabled={inputMode === 'SUBMITTING'}
          onClick={() => this.onSubmitCollab()}
        />

        <input id='pickIMAGE' hidden type="file" accept="image/*" onChange={e => this.onChangeContent(e.target.files, COLLABORATION_IMAGE)} multiple />
        <input id='pickDOCUMENT' hidden type="file" accept=".doc, .docx, .ppt, .pptx, .xls, .xlsx, .pdf" onChange={e => this.onChangeContent(e.target.files, COLLABORATION_DOCUMENT)} multiple />
      </InputWrapper>
    );
  }
}

export default withTheme(CollaborationInput);
